import { Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import useMobile from '../../hooks/useMobile';
import styles from './ReportPreview.module.scss';
import ReportBuilderLink from './ReportBuilderLink';

type Props = {
  backLink: string;
  backLabel: string;
  entityId: string;
};

export const TopBar = ({ entityId, backLink, backLabel }: Props) => {
  const { projectId } = useParams<{
    projectId: string;
  }>();
  const isMobile = useMobile();
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '4rem',
        borderBottom: '1px solid var(--color-grey-dark)',
      }}
      className={styles['analysis-report-preview-container']}
    >
      <Box>
        {entityId && (
          <Link
            to={backLink}
            className={`${styles['reportPreview__back-link']}`}
          >
            <Icon
              name="left-chevron"
              width="14"
              className={`${styles['reportPreview__back-icon']} fill icon-orange`}
            />
            {t('backToKfa', { backLabel })}
          </Link>
        )}
      </Box>
      {!isMobile && (
        <Box>
          <ReportBuilderLink projectId={projectId} />
        </Box>
      )}
    </Box>
  );
};
